// src/components/Button.jsx
import React from 'react';
import { GoArrowUpRight } from "react-icons/go";

const Button = ({ text, onClick, type = "button", className = "" }) => {
    return (
        <>
            <button onClick={onClick} className="flex items-center justify-center space-x-3 hover:bg-[#721C27] px-4 py-2.5 textwhite text-lg cursor-pointer bgcolor w-full transition duration-300">
                <p>{text}</p>
                <GoArrowUpRight className="w-5 h-5 textwhite" />
            </button>
        </>

    );
};

export default Button;